import {
  ResourceContextProvider,
  SimpleForm,
  Title,
  useDataProvider,
  useNotify,
  useRedirect,
  useRefresh,
} from "react-admin";
import { useParams } from "react-router-dom";
import BackButtonToolbar from "features/BackButtonToolbar";
import EditForm from "./Form";
import { CYCLIC_SCHEDULE, DISCIPLINES, PROFESSORS, StudentServicePath } from "utils/constants";
import { studentRequests } from "api/studentApi";

import { checkProps } from "utils/validations";

const EditCyclicDisciplines = () => {
  const { id } = useParams();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  const redirect = useRedirect();

  const handleSubmit = async data => {
    try {
      await dataProvider.customRequest(studentRequests.updateCyclicScheduleDisciplineProfessors(id), data, "PUT");

      notify("Успешно заявена промяна", { type: "success" });
      redirect("list", "student/cyclic-streams");
      refresh();
    } catch (error) {
      checkProps(error, notify);
    }
  };
  return (
    <>
      <Title title={"Редактиране на циклични дисциплини"} />
      <ResourceContextProvider
        value={`${StudentServicePath}${CYCLIC_SCHEDULE}/${DISCIPLINES} + "/:id/" + ${PROFESSORS}`}
      >
        <BackButtonToolbar />
        <SimpleForm onSubmit={handleSubmit}>
          <EditForm />
        </SimpleForm>
      </ResourceContextProvider>
    </>
  );
};
export default EditCyclicDisciplines;
